/**
 * Created by Claude on 07.02.2026
 */

const GeneratorMultiplier = function (slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.customIcon = GeneratorMultiplierIcon;
    this.extraBarWeight = 100001;

    this.onGetView = () => {};

    this.load();
};

GeneratorMultiplier.prototype = Object.create(cleverapps.EventEmitter.prototype);
GeneratorMultiplier.prototype.constructor = GeneratorMultiplier;

GeneratorMultiplier.prototype.load = function () {
    const data = this.slot.load("generatorMultiplier");
    this.value = data && data.value || GeneratorMultiplier.VALUES.X1;
};

GeneratorMultiplier.prototype.save = function () {
    this.slot.save("generatorMultiplier", {
        value: this.value
    });
};

GeneratorMultiplier.prototype.destructor = function () {
    runCleaners(this);
};

GeneratorMultiplier.prototype.getValue = function () {
    return this.value;
};

GeneratorMultiplier.prototype.increment = function () {
    const availableValues = this.getAvailableValues();

    const currentIndex = availableValues.indexOf(this.value);
    const nextIndex = (currentIndex + 1) % availableValues.length;
    this.value = availableValues[nextIndex];

    this.save();
    this.trigger("change", this.value);
};

GeneratorMultiplier.prototype.setValue = function (value) {
    if (this.value === value) {
        return;
    }

    this.value = value;

    this.save();
    this.trigger("change", this.value);
};

GeneratorMultiplier.prototype.getAvailableValues = function () {
    const values = [GeneratorMultiplier.VALUES.X1];

    if (levels.user.checkAvailable(cleverapps.config.availables.GENERATOR_MULTIPLIER_2)) {
        values.push(GeneratorMultiplier.VALUES.X2);
    }

    if (levels.user.checkAvailable(cleverapps.config.availables.GENERATOR_MULTIPLIER_4)) {
        values.push(GeneratorMultiplier.VALUES.X4);
    }

    return values;
};

GeneratorMultiplier.prototype.getAdditionalStage = function () {
    return Math.log2(this.value);
};

GeneratorMultiplier.prototype.isAvailable = function () {
    return levels.user.checkAvailable(cleverapps.config.availables.GENERATOR_MULTIPLIER_2);
};

GeneratorMultiplier.VALUES = {
    X1: 1,
    X2: 2,
    X4: 4
};